
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { useTranslation } from "@/hooks/useTranslation";

interface LeaderboardToggleProps {
  showWorst: boolean;
  onToggleChange: (value: boolean) => void;
}

export function LeaderboardToggle({ showWorst, onToggleChange }: LeaderboardToggleProps) {
  const { t } = useTranslation();
  
  return (
    <div className="flex justify-center mb-4">
      <ToggleGroup type="single" value={showWorst ? "worst" : "best"} onValueChange={(value) => {
        if (value) { // Prevent deselecting both options
          onToggleChange(value === "worst");
        }
      }}>
        <ToggleGroupItem value="best" aria-label="Show best airports" className="px-4">
          {t('best_airports')}
        </ToggleGroupItem>
        <ToggleGroupItem value="worst" aria-label="Show worst airports" className="px-4">
          {t('worst_airports')}
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
}
